import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { API_S3_BASE_URL } from '../../apiConstant';

export const useUpdateS3JsonEditInfo = () => {
  return useMutation({
    mutationFn: async ({ id, jsonEditInfo }) => {
      const res = await axios.put(`${API_S3_BASE_URL}/api/s3/update-json-edit-info`, {
        id,
        jsonEditInfo,
      });
      return res.data;
    },
  });
};
